(ns manage.adset-decision-tree-page.view.side-panel.tagging
  (:require ["@mui/material/Autocomplete$default" :as Autocomplete]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Chip$default" :as Chip]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/TextField$default" :as TextField]
            ["@mui/material/Tooltip$default" :as Tooltip]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            ["src/svg/arrows/arrow-counter-clockwise.svg$default"
             :as ArrowCounterClockwise]
            [cljs-bean.core :refer [->clj]]
            [common.util :as util]
            [common.widgets.form-field :refer [form-field]]
            [manage.adset-decision-tree-page.property :as property]
            [manage.adset-decision-tree-page.tagging-and-trackers.macro-input
             :refer [macro-input]]
            [manage.adset-decision-tree-page.view.context :as context]
            [manage.adset-decision-tree-page.view.side-panel.property-form
             :refer [get-property-field-name use-property-value use-set-property-value]]
            [manage.adset-decision-tree-page.view.side-panel.util
             :as side-panel.util]
            [manage.content-variant-page.entities.tagging.view
             :refer [predefined-attribute-values]]
            [uix.core :as uix :refer [$ defui]]))

(defui parameter-input
  [{:keys [field-path control inherited-value]}]
  ($ rhf/Controller
     {:name field-path
      :control control
      :render (fn [^js props]
                (let [{{:keys [onChange value]} :field} (->clj props)]
                  ($ Autocomplete
                     (util/spread-props
                      (.-field props)
                      {:value (clj->js (or value inherited-value))
                       :size "small"
                       :freeSolo true
                       :placeholder "Type a parameter"
                       :options (to-array predefined-attribute-values)
                       :renderInput (fn [^js props] ($ TextField props))
                       :onInputChange (fn [_ new-input-value] (onChange new-input-value))
                       :onChange (fn [_e value] (onChange value))}))))}))

(defui rhf-controlled-macro-input [{:keys [field-path control]}]
  ($ rhf/Controller
     {:name field-path
      :control control
      :render (fn [^js props]
                (let [{{:keys [onChange value onBlur]} :field} (->clj props)]
                  ($ macro-input {:sx #js {:flexGrow 1}
                                  :value (or (first value) "")
                                  :allow-macros? true
                                  :on-change #(onChange [%])
                                  :on-blur onBlur})))}))

(defui query-param-list-item [{:keys [get-field-path delete-item control]}]
  ($ Stack {:direction "row"
            :spacing 1
            :alignItems "center"}
     ($ form-field
        {:sx #js {:flexBasis "34%"}
         :label "Parameter"
         :data-testid "query-param-attribute-input"}
        ($ parameter-input {:control control
                            :field-path (get-field-path "name")}))
     ($ form-field
        {:sx #js {:flexBasis "66%"}
         :label ($ Stack
                   {:direction "row"
                    :alignItems "center"
                    :spacing 0.5}
                   ($ Typography
                      {:component "label"
                       :fontWeight "600"
                       :data-component :form-field__label}
                      "Value")
                   ($ Tooltip
                      {:placement "top"
                       :title "Unlock the power of dynamic macros by typing \"${xxx}\""}
                      ($ Icon {:fontSize "small"} "info")))
         :data-testid "query-param-value-input"}
        ($ rhf-controlled-macro-input {:control control
                                       :field-path (get-field-path "values")}))
     ($ IconButton
        {:sx #js {:alignSelf "flex-end"}
         :onClick delete-item
         :data-testid "delete-query-param"}
        ($ Icon "delete"))))

(defui ad-variant-tagging-editor [{:keys [form-control property]
                                   {:keys [append remove fields]} :field-array}]
  (let [root-node (context/use-property-context property)
        root-tagging-value (get-in root-node property/tagging-data-path)
        tagging-value (use-property-value form-control property)
        set-tagging-value (use-set-property-value form-control property)]
    ($ side-panel.util/collapsible-wrapper
       {:label "Tagging"
        :collapsed-label (str "Tagging (" (count tagging-value) ")")
        :header-content (if (= (->clj tagging-value) root-tagging-value)
                          ($ Chip {:label "Inherited"
                                   :size "small"
                                   :sx #js {:mr 1}})
                          ($ Button {:startIcon ($ ArrowCounterClockwise {:width 20
                                                                          :height 20})
                                     :onClick (partial set-tagging-value
                                                       (clj->js root-tagging-value))}
                             "Reset values"))}
       ($ Stack {:direction "column"
                 :spacing 2}
          (map-indexed
           (fn [index ^js field]
             ($ query-param-list-item
                {:key (.-id field)
                 :control (:control form-control)
                 :get-field-path (partial get-property-field-name property (str index))
                 :delete-item (partial remove index)}))
           fields)
          ($ Button {:startIcon ($ Icon "add")
                     :variant "text"
                     :onClick (partial append #js {:name "" :values #js [""]})
                     :sx #js {:alignSelf "flex-start"}}
             "Add new parameter")))))
